import { observer } from 'mobx-react-lite';

import { IconAppExtraSmall } from '@components/icons/app-extra-small';
import { Stack } from '@components/stack';
import { Tag } from '@components/tag';

import { useIntegrationLabels } from 'hooks/use-integration-labels';
import { useStore } from 'models/Provider';
import { IApplication } from 'models/types';

export const ApplicationLabels = observer(({ application }: { application: IApplication }) => {
  const { t } = useStore();
  const isNew = application.userRead && !application.userRead.newApplication;
  const integrationsLabels = useIntegrationLabels(application.integrationsResults);
  return (
    <Stack orientation="horizontal" space={1} wrap>
      {application.referredBy && (
        <Tag variant="blue" size="small" text={t('application.label.sourced')} />
      )}
      {application.isNotifiedOfRejection && (
        <Tag variant="red" size="small" text={t('application.label.rejectionsent')} />
      )}
      {isNew && <Tag variant="green" size="small" text={t('application.label.new')} />}
      {application.isRetracted && (
        <Tag variant="orange" size="small" text={t('application.label.retracted')} />
      )}
      {application.isManuallyAdded && (
        <Tag variant="purple" size="small" text={t('application.label.manuallyadded')} />
      )}
      {integrationsLabels?.map((label) => (
        <Tag
          key={label.text}
          variant={label.variant}
          size="small"
          text={label.text}
          icon={<IconAppExtraSmall />}
        />
      ))}
    </Stack>
  );
});
